/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Anywhere_BodyInputs */

const en_funnel_sq_anywhere_body = /** @type {(inputs: Funnel_Sq_Anywhere_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start on your laptop, keep going on your phone, and let the Chrome extension read any website out loud. One subscription syncs across everything.`)
};

const es_funnel_sq_anywhere_body = /** @type {(inputs: Funnel_Sq_Anywhere_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza en tu portátil, sigue en el móvil y deja que la extensión de Chrome te lea cualquier web en voz alta. Una sola suscripción se sincroniza en todo.`)
};

/**
* | output |
* | --- |
* | "Start on your laptop, keep going on your phone, and let the Chrome extension read any website out loud. One subscription syncs across everything." |
*
* @param {Funnel_Sq_Anywhere_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_anywhere_body = /** @type {((inputs?: Funnel_Sq_Anywhere_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Anywhere_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_anywhere_body(inputs)
	return en_funnel_sq_anywhere_body(inputs)
});